<template>
  <div class="bg-[#16131B] h-[72px] flex justify-center">
    <div class="xxl:max-w-[1312px] w-full flex justify-between items-center px-6 py-3">
      <div class="flex gap-[24px]">
        <!-- Logo -->
        <div>
          <a :href="goToWebsite('/')">
            <img src="@/assets/svgs/ohbb_logo.svg" class="w-[36px]" />
          </a>
        </div>
        <!-- Navigation -->
        <div class="flex-row items-center gap-8 text-[#9C93B3] font-['Rubik'] text-sm font-[400] lg:flex hidden">
          <div class="dropdown" ref="dropdown">
            <div class="flex flex-row items-center cursor-pointer hover:text-[#EFEDF2]" :onclick="clickOBK">
              Games
              <img
                src="@/assets/images/homepage/arrow-filled-down.svg"
                alt="chevron"
                class="w-3 h-3 ml-1"
                :class="
                  OBKVisibility === 'flex'
                    ? 'rotate-180 transform transition-transform'
                    : 'transform transition-transform'
                " />
            </div>
            <div class="w-full absolute z-[100] bg-[#221E2A] mt-[26px] left-0" :class="OBKVisibility">
              <GamesSectionNavbar />
            </div>
          </div>

          <a :onclick="goToSite" class="hover:text-[#EFEDF2] cursor-pointer">Website</a>
          <a :onclick="goToMarketplace" class="hover:text-[#EFEDF2] cursor-pointer">Marketplace</a>
          <a :href="goToWebsite('/news')" class="hover:text-[#EFEDF2]">News</a>
          <a :href="goToWebsite('/support')" class="hover:text-[#EFEDF2]">Support</a>

          <div class="dropdown" ref="dropdown">
            <div class="flex flex-row items-center cursor-pointer hover:text-[#EFEDF2]" :onclick="clickLM">
              Learn More
              <img
                src="@/assets/images/homepage/arrow-filled-down.svg"
                alt="chevron"
                class="w-3 h-3 ml-1"
                :class="
                  LMVisibility === 'flex'
                    ? 'rotate-180 transform transition-transform'
                    : 'transform transition-transform'
                " />
            </div>
            <div class="w-[129px] absolute z-[100] bg-[#322C3F] rounded-lg mt-[26px]" :class="LMVisibility">
              <div class="text-[#EFEDF2] font-['Rubik'] text-sm font-[400] flex flex-col py-2">
                <a :href="goToWebsite('/about-us')" class="mx-[16px] my-[10px]">Company</a>
                <a :href="goToWebsite('/careers')" class="mx-[16px] my-[10px]">Work With Us</a>
                <a :href="goToWebsite('/developers')" class="ml-[16px] my-[10px]">Partner With Us</a>
              </div>
            </div>
          </div>

          <div class="dropdown" ref="dropdown" v-if="userToken">
            <div
              class="flex flex-row items-center cursor-pointer text-[#9C93B3] hover:text-[#EFEDF2]"
              :onclick="clickPass">
              OBB Pass
              <img
                src="@/assets/images/homepage/arrow-filled-down.svg"
                alt="chevron"
                class="w-3 h-3 ml-1"
                :class="
                  PassVisibility === 'flex'
                    ? 'rotate-180 transform transition-transform'
                    : 'transform transition-transform'
                " />
              <div class="text-primaryRed text-xs font-medium leading-3 p-2 bg-[#28010A] rounded-3xl ml-[8px]">New</div>
            </div>
            <div class="w-[129px] absolute z-[100] bg-[#322C3F] rounded-lg mt-[22px]" :class="PassVisibility">
              <div class="text-[#EFEDF2] font-['Rubik'] text-sm font-[400] flex flex-col py-2">
                <a :href="goToWebsite('/pass')" class="mx-[16px] my-[10px]">My NFTs</a>
                <a :href="goToWebsite('/pass/leaderboard/1')" class="mx-[16px] my-[10px]">OBB Passes</a>
              </div>
            </div>
          </div>
        </div>
      </div>
      <!-- Account/Play/Hamburger -->
      <div class="flex flex-row items-center gap-6 relative">
        <div class="dropdown" ref="dropdown">
          <div class="flex flex-row items-center gap-[24px] cursor-pointer">
            <button @click="goToLearnMore"
              class="lg:flex hidden secondary-large w-[101px] h-[32px] font-Rubik text-mainText font-medium whitespace-nowrap sm:flex items-center justify-center">
              <img src="@/assets/icons/download.svg" class="w-[12px] h-[12px] download-btn" />
              <span class="button-small ml-[4px]">Install app</span>
            </button>
            <div class="flex items-center gap-[8px]" :onclick="clickAccount">
              <div class="bg-[#483F5A] w-8 h-8 flex items-center justify-center rounded-[100px]">
                <img :src="userData ? userData.image : pfpSvg" class="rounded-full" />
              </div>
              <img
                src="@/assets/images/homepage/arrow-filled-down.svg"
                alt="chevron"
                class="w-3 h-3"
                :class="
                  LoginVisibility === 'flex'
                    ? 'rotate-180 transform transition-transform'
                    : 'transform transition-transform'
                " />
            </div>
          </div>

          <div
            class="w-[129px] absolute z-[100] bg-[#322C3F] rounded-lg mt-[20px] lg:right-[1%] xl:right-[1%] right-[5%] xxxl:right-[1%]"
            :class="LoginVisibility"
            v-if="!userToken">
            <div class="text-[#EFEDF2] font-['Rubik'] text-sm font-[400] flex flex-col py-2">
              <a :onclick="login" class="mx-[16px] my-[10px] cursor-pointer">Login</a>
              <a :onclick="signup" class="mx-[16px] my-[10px] cursor-pointer">Sign Up</a>
            </div>
          </div>

          <div
            class="w-[250px] absolute z-[100] bg-[#322C3F] rounded-lg mt-[20px] lg:right-[1%] xl:right-[1%] right-[5%] sm:right-[7%] xxxl:right-[1%]"
            :class="LoginVisibility"
            v-if="userToken">
            <div class="text-[#EFEDF2] font-['Rubik'] text-sm font-[400] flex flex-col w-full py-2">
              <div class="flex flex-row items-center gap-2 border-b-[1px] border-[#483f5a] pt-2 px-4 pb-[20px]">
                <div
                  class="bg-[#483F5A] w-8 h-8 flex items-center justify-center rounded-[100px] cursor-pointer"
                  :onclick="clickAccount">
                  <img :src="userData ? userData.image : pfpSvg" class="rounded-full cursor-default" />
                </div>
                <div class="max-w-[170px] overflow-hidden">
                  <h1 class="text-base font-medium text-left truncate text-mainText font-Rubik">
                    {{ userData ? userData.displayName : '' }}
                  </h1>
                  <p class="text-xs font-normal text-left truncate text-secText font-Rubik">
                    {{ userData ? userData.email : '' }}
                  </p>
                </div>
              </div>

              <div class="px-4 py-1 border-b-[1px] border-[#483f5a] flex flex-row items-center">
                <div class="flex flex-row items-center gap-2 cursor-pointer" :onclick="goToSettings">
                  <img src="@/assets/icons/settings.svg" class="w-[20px] h-[20px]" />
                  <h1 class="font-Rubik py-[10px] text-sm font-normal">Account Settings</h1>
                </div>
              </div>

              <div class="flex flex-row items-center px-4 py-1">
                <div class="flex flex-row items-center gap-2 cursor-pointer" :onclick="logout">
                  <img src="@/assets/icons/logout.svg" class="w-[20px] h-[20px]" />
                  <h1 class="font-Rubik py-[10px] text-sm font-normal">Log out</h1>
                </div>
              </div>
            </div>
          </div>
        </div>

        <!-- Hamburger Menu -->
        <div
          class="hamburger hamburger--vortex lg:hidden"
          :class="showMenu ? 'is-active' : ''"
          @click="toggleHamburgerMenu">
          <div class="hamburger-box">
            <div class="hamburger-inner"></div>
          </div>
        </div>
      </div>
    </div>

    <!-- Hamburger menu content -->
    <div class="w-full bg-[#16131B] absolute lg:hidden z-[100] mt-[72px]" v-if="showMenu">
      <div class="text-[#9C93B3] font-['Rubik'] text-base font-[600] flex flex-col">
        <a
          :href="goToWebsite('/overview')"
          class="py-[10px] px-[32px] flex flex-row items-center justify-between cursor-pointer bg-[#16131B]">
          Oh Baby! Kart
        </a>
        <a :href="goToWebsite('/shogun-curse')" class="py-[10px] px-[32px] cursor-pointer">Shogun Curse</a>
        <a :href="goToWebsite('/bam-bam-boom')" class="py-[10px] px-[32px] cursor-pointer">Bam Bam Boom</a>
        <a :href="goToWebsite('/pawker')" class="py-[10px] px-[32px] cursor-pointer">Pawker</a>
        <div
          class="py-[10px] px-[32px] flex flex-row items-center justify-between cursor-pointer"
          @click="clickOBK"
          :class="OBKVisibility === 'flex' ? 'bg-[#322C3F] border-l-[#ED063D] border-l-[2px]' : 'bg-[#16131B]'">
          Inside OBK
          <img
            src="@/assets/images/homepage/arrow-filled-down.svg"
            alt="chevron"
            class="w-4 h-4 ml-1"
            :class="
              OBKVisibility === 'flex' ? 'rotate-180 transform transition-transform' : 'transform transition-transform'
            " />
        </div>
        <div class="flex flex-col bg-[#0E0D12] px-[32px]" :class="OBKVisibility">
          <a :href="goToWebsite('/overview')" class="my-[10px]">How to play</a>
          <a :href="goToWebsite('/leaderboard/oh-baby-kart')" class="my-[10px]">Leaderboards</a>
          <a :href="goToWebsite('/twitch-drops')" class="my-[10px]">Twitch Drops</a>
          <a target="_blank" href="https://ohbabykart.wiki.gg/wiki/Characters" class="my-[10px]">Heroes</a>
          <a :href="goToWebsite('/stages')" class="py-[10px]">Stages</a>
        </div>
        <a :onclick="goToSite" class="py-[10px] px-[32px] cursor-pointer">Website</a>
        <a :onclick="goToMarketplace" class="py-[10px] px-[32px] cursor-pointer">Marketplace</a>
        <a :href="goToWebsite('/news')" class="py-[10px] px-[32px]">News</a>
        <a :href="goToWebsite('/support')" class="py-[10px] px-[32px]">Support</a>

        <div
          class="py-[10px] px-[32px] flex flex-row items-center justify-between cursor-pointer"
          @click="clickLM"
          :class="LMVisibility === 'flex' ? 'bg-[#322C3F] shadow-[inset_#ED063D_2px_0px_0px_0px]' : 'bg-[#16131B]'">
          Learn More
          <img
            src="@/assets/images/homepage/arrow-filled-down.svg"
            alt="chevron"
            class="w-4 h-4 ml-1"
            :class="
              LMVisibility === 'flex' ? 'rotate-180 transform transition-transform' : 'transform transition-transform'
            " />
        </div>
        <div class="flex flex-col bg-[#0E0D12] px-[32px]" :class="LMVisibility">
          <a :href="goToWebsite('/about-us')" class="py-[10px]">Company</a>
          <a :href="goToWebsite('/careers')" class="py-[10px]">Work With Us</a>
          <a :href="goToWebsite('/developers')" class="py-[10px]">Partner With Us</a>
        </div>

        <div
          v-if="userToken"
          class="py-[10px] px-[32px] flex flex-row items-center justify-between cursor-pointer"
          @click="clickPass"
          :class="PassVisibility === 'flex' ? 'bg-[#322C3F] shadow-[inset_#ED063D_2px_0px_0px_0px]' : 'bg-[#16131B]'">
          <div class="flex flex-row items-center justify-center text-[#9C93B3]">
            OBB Pass
            <div class="text-primaryRed text-xs font-medium leading-3 p-2 bg-[#28010A] rounded-3xl ml-[8px]">New</div>
          </div>
          <img
            src="@/assets/images/homepage/arrow-filled-down.svg"
            alt="chevron"
            class="w-4 h-4 ml-1"
            :class="
              PassVisibility === 'flex' ? 'rotate-180 transform transition-transform' : 'transform transition-transform'
            " />
        </div>
        <div class="flex flex-col bg-[#0E0D12] px-[32px]" :class="PassVisibility">
          <a :href="goToWebsite('/pass')" class="py-[10px] text-[#9C93B3]">My NFTs</a>
          <a :href="goToWebsite('/pass/leaderboard/1')" class="py-[10px] text-[#9C93B3]">OBB Passes</a>
        </div>
      </div>

      <div class="flex flex-row items-center px-4 py-[10px] cursor-pointer">
        <button @click="goToLearnMore"
          class="flex secondary-large w-full sm:hidden h-[48px] font-Rubik text-mainText font-medium whitespace-nowrap items-center justify-center">
          <img src="@/assets/icons/download.svg" class="w-[12px] h-[12px] download-btn" />
          <span class="button-large ml-[4px]">Install app</span>
        </button>
      </div>
    </div>
  </div>
</template>

<script>
import HamburgerMenu from '@/assets/icons/hamburger_menu.svg';
import CloseIcon from '@/assets/icons/close.svg';
import personSvg from '@/assets/icons/person.svg';

import envConfig from '../config';
import axios from 'axios';

import './hamburger.css';

import GamesSectionNavbar from './GamesSectionNavbar.vue';

export default {
  components: { GamesSectionNavbar },

  data() {
    return {
      OBKVisibility: 'hidden',
      LMVisibility: 'hidden',
      LoginVisibility: 'hidden',
      PassVisibility: 'hidden',
      showMenu: false,
      userToken: null,
      userData: null,
      allow_store: false,
    };
  },

  mounted() {
    this.userToken = window.getCookie('obb_ck');
    this.fetchUser();
  },

  methods: {
    clickOBK() {
      if (this.OBKVisibility === 'hidden') {
        this.LMVisibility = 'hidden';
        this.LoginVisibility = 'hidden';
        this.PassVisibility = 'hidden';
        this.OBKVisibility = 'flex';
      } else this.OBKVisibility = 'hidden';
    },

    clickLM() {
      if (this.LMVisibility === 'hidden') {
        this.OBKVisibility = 'hidden';
        this.LoginVisibility = 'hidden';
        this.PassVisibility = 'hidden';
        this.LMVisibility = 'flex';
      } else this.LMVisibility = 'hidden';
    },

    clickAccount() {
      if (this.LoginVisibility === 'hidden') {
        this.OBKVisibility = 'hidden';
        this.LMVisibility = 'hidden';
        this.PassVisibility = 'hidden';
        this.LoginVisibility = 'flex';
      } else this.LoginVisibility = 'hidden';
    },

    toggleHamburgerMenu() {
      this.showMenu = !this.showMenu;
      this.LMVisibility = 'hidden';
      this.OBKVisibility = 'hidden';
    },

    clickPass() {
      if (this.PassVisibility === 'hidden') {
        this.OBKVisibility = 'hidden';
        this.LoginVisibility = 'hidden';
        this.LMVisibility = 'hidden';
        this.PassVisibility = 'flex';
      } else this.PassVisibility = 'hidden';
    },

    joinWaitlist() {
      if (!this.userToken) {
        window.location.href = envConfig.websiteUrl + `/login?signup`;
      } else if (this.userToken) {
        window.location.href = envConfig.websiteUrl + `/profile`;
      }
    },

    login() {
      window.location.href = `${envConfig.websiteUrl}/login?from=store`;
    },

    logout() {
      let cookieValue = this.userToken;
      let expDate = new Date();
      expDate.setFullYear(expDate.getFullYear() - 1);
      document.cookie =
        'obb_ck=' +
        cookieValue +
        ';expires=' +
        expDate +
        (window.location.hostname !== 'localhost' ? ';domain=.ohbabygames.com' : '') +
        ';path=/';

      window.location.href = '/';
    },

    signup() {
      window.location.href = envConfig.websiteUrl + `/login?signup`;
    },

    goToSite() {
      window.location.href = envConfig.websiteUrl;
    },

    goToMarketplace() {
      window.location.href = envConfig.websiteUrl + '/marketplace';
    },

    fetchUser() {
      const url = envConfig.baseUrl + '/api/user';

      if (this.userToken) {
        axios
          .get(url, {
            headers: {
              Authorization: `Bearer ${this.userToken}`,
              'Content-Type': 'application/json',
            },
          })
          .then((response) => {
            const data = response.data;
            this.userData = data.data;
            if (this.userData.allow_store) {
              this.allow_store = true;
            }
          })
          .catch((error) => {
            console.log(error);
          });
      }
    },

    goToLearnMore() {
      window.location.href = envConfig.websiteUrl + '/download-platform';
    },

    goToSettings() {
      window.location.href = envConfig.websiteUrl + '/account-settings';
    },

    claimSteamKey() {
      window.location.href = envConfig.websiteUrl + '/profile';
    },

    goToWebsite(relPath) {
      if (relPath) {
        return envConfig.websiteUrl + relPath;
      } else {
        return envConfig.websiteUrl;
      }
    },
  },

  computed: {
    HamburgerMenuIcon() {
      return this.showMenu ? CloseIcon : HamburgerMenu;
    },
    pfpSvg() {
      return personSvg;
    },
  },
};
</script>

<style scoped>
.profile-name {
  max-width: 190px;
}

@media all and (max-width: 320px) {
  .profile-name {
    max-width: 120px;
  }
}

.download-btn {
  filter: brightness(0) invert(1);
}
</style>
